import { LIVE_EDITOR_STEP_KEYS, type LiveEditorStepKey } from "@simplyk/common";

export type LiveEditorStep = number;

export type { LiveEditorStepKey };

export const isValidStepKey = (key: unknown): key is LiveEditorStepKey =>
  typeof key === "string" && LIVE_EDITOR_STEP_KEYS.some((stepKey) => stepKey === key);

const LEGACY_TICKETING_STEP_KEYS: ReadonlySet<string> = new Set(["thank-you-email", "thank-you-email-not-winner"]);

export const isLegacyTicketingStepKey = (key: unknown, formType: string): boolean =>
  formType === "ticketing" && typeof key === "string" && LEGACY_TICKETING_STEP_KEYS.has(key);

export const coerceLegacyTicketingStepKey = <T extends string | null | undefined>(key: T, formType: string): T =>
  isLegacyTicketingStepKey(key, formType) ? ("automated-communications" as unknown as T) : key;

export const isRemovedStepKey = (key: unknown): boolean => key === "collaborators";

export const coerceRemovedStepKey = <T extends string | null | undefined>(key: T): T =>
  isRemovedStepKey(key) ? ("advanced-settings" as unknown as T) : key;
